import React from 'react'

import { OpenInNew } from '@material-ui/icons'

import { Chip, KeyValue, KeyLabel, KeyVal } from '../styles'

const Field = ({ field, onClick }) => {
	if (field.kind === 'kv') {
		return (
			<KeyValue $bordered={field.link} onClick={onClick} style={onClick ? { cursor: 'pointer' } : undefined}>
				<KeyLabel>{field.label}:</KeyLabel>
				<KeyVal $color={field.link ? 'info' : field.valueColor}>{field.value}</KeyVal>
				{field.link && <OpenInNew style={{ fontSize: '1em' }} />}
			</KeyValue>
		)
	}

	return (
		<Chip $color={field.color} $variant={field.variant} $square={field.square} $clickable={!!onClick} onClick={onClick}>
			{field.label}
			{field.value != null &&
				(field.valueColor ? (
					<>
						:&nbsp;<KeyVal $color={field.valueColor}>{field.value}</KeyVal>
					</>
				) : (
					`: ${field.value}`
				))}
			{field.link && <OpenInNew />}
		</Chip>
	)
}

export default Field
